import React from 'react';
import { UseMutationResult } from '@tanstack/react-query';
import { ChevronDownIcon, MessageCircleWarning } from 'lucide-react';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Icons } from '@/components/icons';

interface IMutationStatusIndicatorProps {
  mutation: UseMutationResult<any, any, any>;
}

const MutationStatusIndicator: React.FC<IMutationStatusIndicatorProps> = ({
  mutation,
}) => {
  if (mutation.isPending)
    return <Icons.spinner className="ml-2 h-4 w-4 animate-spin" />;

  if (mutation.isError)
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <MessageCircleWarning className="ml-2 h-4 w-4 text-red-500" />
          </TooltipTrigger>
          <TooltipContent>
            <p>
              An error occurred while updating the user roles. Please try again.
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );

  return <ChevronDownIcon className="ml-2 h-4 w-4" />;
};

export default MutationStatusIndicator;
